import { render } from "./SmallAbout.vue?vue&type=template&id=c53314bc"
import script from "./SmallAbout.vue?vue&type=script&lang=js"
export * from "./SmallAbout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__